import { postRequest } from '../../../helpers/request';

export default {
  namespaced: true,

  state: () => ({
    dashboard: null,
    loading: false,
    error: null,
  }),

  getters: {
    hasHedges: (state) => (state.dashboard?.open_positions || []).length > 0
      || (state.dashboard?.hedge_program_ytd?.n_closed || 0) > 0,

    hasCashContracts: (state) => (state.dashboard?.cash_contracts || []).length > 0,

    hasCoverage: (state) => (state.dashboard?.coverage || []).length > 0,

    hasContracts: (state, getters) => getters.hasHedges
      || getters.hasCashContracts
      || (state.dashboard?.ledger || []).length > 0,

    coverageTotals: (state) => (state.dashboard?.coverage || []).reduce((totals, row) => ({
      expected: totals.expected + (row.expected_bu || 0),
      sold: totals.sold + (row.sold_bu || 0),
      hedged: totals.hedged + (row.hedged_bu || 0),
      open: totals.open + (row.open_bu || 0),
    }), {
      expected: 0, sold: 0, hedged: 0, open: 0,
    }),
  },

  mutations: {
    setDashboard(state, data) {
      state.dashboard = data;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setError(state, err) {
      state.error = err;
    },
  },

  actions: {
    async fetchDashboard({ commit }, { cropYearId, unitId } = {}) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const params = { crop_year_id: cropYearId };
        if (unitId) params.unit_id = unitId;
        const data = await postRequest('/farm_profile/api/hedgeflow/dashboard/', params);
        commit('setDashboard', data);
      } catch (err) {
        commit('setError', err?.message || 'Failed to load HedgeFlow data.');
        commit('setDashboard', null);
      } finally {
        commit('setLoading', false);
      }
    },

    async closePosition({ dispatch }, {
      contractId, numberOfContracts, price, operationDate, cropYearId, unitId,
    }) {
      await postRequest('/farm_profile/api/create_contract_operation/', {
        contract: contractId,
        operation_type: 'close',
        number_of_contracts: numberOfContracts,
        operation_date: operationDate,
        price,
      });
      await dispatch('fetchDashboard', { cropYearId, unitId });
    },
  },
};
